import { render } from "./CardProfile.vue?vue&type=template&id=50e671e2&scoped=true"
import script from "./CardProfile.vue?vue&type=script&lang=js"
export * from "./CardProfile.vue?vue&type=script&lang=js"

import "./CardProfile.vue?vue&type=style&index=0&id=50e671e2&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e671e2"]])

export default __exports__